import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "./../../common/form/form";
import SignUpLeftBar from "../common/signUpLeftBar";
import AlertSuccess from "../../common/alertSuccess";
import AlertError from "../../common/alertError";
import { Tooltip as ReactTooltip } from "react-tooltip";
import Select from "react-select";
import {
  doctorUpdate,
  getDoctor,
  loadDoctorProfile,
  loadDoctorProfileForStaff,
} from "../../../store/doctor";

import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getDoctorToken,
  getStaffToken,
  setDoctorToken,
} from "../../services/localStorageServices";
import {
  clinicAddressRequired,
  cityRequired,
  stateRequired,
  picsRequired,
  drPersonalDetailFaild,
  profileUpdatedSuccess,
  nameRequired,
  zipRequired,
  phoneRequired,
  phoneInvalid,
} from "../../common/misc";
import FileInput from "../../common/form/fileInput";
import { getMisc, loadCity, loadState } from "../../../store/misc";
import seUploadFun from "../../services/s3Services";
import SubmitBtn from "../../common/form/submitBtn";
import HelpText from "./helpText";
class Clinic extends Form {
  state = {
    stateOnchange: false,
    states: [],
    cities: [],
    btnClass: "btn btn-primary btn-lg",
    loading: false,
    data: {
      phone: "",
      is_available: false,
      name: "",
      clinicaddress: "",
      city: "",
      state: "",
      zipcode: "",
      pics: [],
      googleProfile: "",
      phone_2: "",
      is_available_2: false,
      name_2: "",
      clinicaddress_2: "",
      city_2: "",
      state_2: "",
      zipcode_2: "",
      pics_2: [],
      googleProfile_2: "",
    },
    errors: {},
  };

  schema = {
    is_available: Joi.any(),
    phone: Joi.number()
      .required()
      .min(1000000000)
      .max(999999999999999)
      .error((errors) => {
        errors.forEach((err) => {
          console.log("errerr", err);
          switch (err.type) {
            case "any.required":
              err.message = phoneRequired;
              break;
            case "number.base":
              err.message = phoneInvalid;
              break;

            case "number.max":
              err.message = phoneInvalid;
              break;

            case "number.min":
              err.message = phoneInvalid;
              break;
          }
        });
        return errors;
      }),
    name: Joi.string()
      .required()
      .error(() => {
        return { message: nameRequired };
      }),
    clinicaddress: Joi.string()
      .required()
      .error(() => {
        return { message: clinicAddressRequired };
      }),
    city: Joi.string()
      .required()
      .error(() => {
        return { message: cityRequired };
      }),
    state: Joi.string()
      .required()
      .error(() => {
        return { message: stateRequired };
      }),

    zipcode: Joi.string()
      .required()
      .error(() => {
        return { message: zipRequired };
      }),

    pics: Joi.array()
      .items(Joi.string().required())
      .required()
      .error(() => {
        return { message: picsRequired };
      }),
    googleProfile: Joi.string()
      .uri()
      .allow("")
      .label("Google Profile Link")
      .error(() => {
        return { message: "Enter a valid Google Profile link" };
      }),

    is_available_2: Joi.any(),
    phone_2: Joi.number()
      .min(1000000000)
      .max(999999999999999)
      .allow('', null)
      .optional()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "number.base":
            case "number.max":
            case "number.min":
              err.message = phoneInvalid;
              break;
          }
        });
        return errors;
      }),

    name_2: Joi.string().allow('', null).optional(),

    clinicaddress_2: Joi.string().allow('', null).optional(),

    city_2: Joi.string().allow('', null).optional(),

    state_2: Joi.string().allow('', null).optional(),

    zipcode_2: Joi.string().allow('', null).optional(),

    pics_2: Joi.array()
      .items(Joi.string())
      .optional(),

    googleProfile_2: Joi.string()
      .uri()
      .allow('')
      .optional()
      .label("Google Profile Link"),

  };
  customStyles = {
    indicatorSeparator: (styles) => ({ display: "none" }),
    option: (provided, state) => ({
      ...provided,
      "&:hover": {
        backgroundColor: "rgb(95, 50, 187, 10%)",
        color: "#621ac0",
      },

      color: state.isSelected ? "#621ac0" : "black",
      backgroundColor: state.isSelected
        ? "rgb(95, 50, 187, 10%)"
        : provided.backgroundColor,
    }),
    control: (base, { isDisabled }) => ({
      ...base,
      minHeight: 60,
      borderColor: "#e0e0e0",
      borderRadius: 8,
      boxShadow: "0 !important",
    }),
  };
  remoVeImg = (e, i) => {
    e.preventDefault();
    const data = this.state.data;
    const pics = data.pics;
    data.pics = pics.filter((p) => p !== i);
    this.setState({ data });
  };
  remoVeImg2 = (e, i) => {
    e.preventDefault();
    const data = this.state.data;
    const pics = data.pics_2;
    data.pics_2 = pics.filter((p) => p !== i);
    this.setState({ data });
  };
  fileUpload = (e) => {
    const _id = this.props.doctorProfile._id;
    const files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      const element = files[i];
      const fileName =
        "doctor/" +
        _id +
        "/clinic/" +
        Date.now() +
        "-" +
        element.lastModified +
        "-" +
        element.size;
      const res = seUploadFun(element, fileName);
      res.then((result) => {
        const { data, errors } = this.state;
        errors.pics = "";
        data.pics = [result.key];
        this.setState({ data, errors });
      });
    }
  };

  fileUpload2 = (e) => {
    const _id = this.props.doctorProfile._id;
    const files = e.target.files;
    for (var i = 0; i < files.length; i++) {
      const element = files[i];
      const fileName =
        "doctor/" +
        _id +
        "/clinic/" +
        Date.now() +
        "-" +
        element.lastModified +
        "-" +
        element.size;
      const res = seUploadFun(element, fileName);
      res.then((result) => {
        const { data, errors } = this.state;
        errors.pics_2 = "";
        data.pics_2 = [result.key];
        this.setState({ data, errors });
      });
    }
  };

  doSubmit = () => {
    const {
      is_available,
      name,
      clinicaddress,
      city,
      state,
      pics,
      zipcode,
      phone,
      googleProfile,

      is_available_2,
      name_2,
      clinicaddress_2,
      city_2,
      state_2,
      pics_2,
      zipcode_2,
      phone_2,
      googleProfile_2,
    } = this.state.data;

    const payLoad = {
      clinic_details: {
        is_available,
        zipcode,
        name,
        state,
        address: clinicaddress,
        cityId: city,
        photos: pics,
        googleProfile,
      },

      clinic_details_2: {
        is_available: is_available_2,
        zipcode: zipcode_2,
        name: name_2,
        state: state_2,
        address: clinicaddress_2,
        cityId: city_2 || null,
        photos: pics_2,
        googleProfile: googleProfile_2,
      },
    };
    if (phone) payLoad.clinic_details.phone = phone;
    if (phone_2) payLoad.clinic_details_2.phone = phone_2;

    if (!this.state.loading) {
      this.setState({
        btnClass: "btn btn-primary btn-lg disabled",
        loading: true,
      });
      this.props.doctorUpdate(payLoad, this.callBack);
    }
  };

  callBack = (res) => {
    this.setState({
      btnClass: "btn btn-primary btn-lg",
      loading: false,
    });
    if (res.status === 200) {
      this.props.history.push("/doctor/sign-up/associations");
      toast(<AlertSuccess message={profileUpdatedSuccess} />);
      if (getStaffToken("auth")) {
        this.props.loadDoctorProfileForStaff();
      } else {
        this.props.loadDoctorProfile();
      }
    } else {
      toast(<AlertError message={drPersonalDetailFaild} />);
    }
  };

  componentDidMount = () => {
    if (getDoctorToken("auth")) {
      this.props.loadDoctorProfile();
      this.props.loadState();
    } else if (getStaffToken("auth")) {
      this.props.loadDoctorProfileForStaff();
    } else {
      this.props.history.push("/doctor/sign-up/personal-detail");
    }
  };

  // componentDidUpdate = (prevProps, prevState) => {
  //   window.$('#state').niceSelect('update')
  //   if (
  //     !this.props.profileLoading &&
  //     this.props.profileLoading !== prevProps.profileLoading
  //   ) {
  //     const {
  //       address,
  //       cityId,
  //       is_available,
  //       name,
  //       photos,
  //       state,
  //       zipcode,
  //       phone,
  //       googleProfile
  //     } = this.props.doctorProfile.clinic_details
  //     const data = {
  //       is_available,
  //       name,
  //       clinicaddress: address,
  //       city: cityId,
  //       state,
  //       zipcode,
  //       phone: is_available ? '' : phone,
  //       pics: photos.map(e => e),
  //       googleProfile
  //     }
  //     if (is_available) {
  //       this.schema.name = Joi.any()
  //       this.schema.pics = Joi.any()
  //       this.schema.phone = Joi.any()
  //       this.schema.clinicaddress = Joi.any()
  //     }
  //     this.props.loadState()
  //     this.props.loadCity({ state: data.state })
  //     this.setState({ data })
  //   }
  //   if (
  //     !this.props.getMisc.loadingState &&
  //     this.props.getMisc.loadingState !== prevProps.getMisc.loadingState
  //   ) {
  //     const states = this.props.getMisc.state.map(ele => ({
  //       _id: ele,
  //       name: ele,
  //     }))
  //     this.setState({ states }, () => {
  //       window.$('#state').niceSelect('update')
  //       window.$('.state').on('change', () => {
  //         const data = this.state.data
  //         if (data.state !== window.$('#state').val()) {
  //           data.state = window.$('#state').val()
  //           this.setState({ data })
  //           this.props.loadCity({ state: data.state })
  //         }
  //       })
  //     })
  //   }

  //   if (
  //     !this.props.getMisc.loadingCity &&
  //     this.props.getMisc.loadingCity !== prevProps.getMisc.loadingCity
  //   ) {
  //     const states = this.props.getMisc.state.map(ele => ({
  //       _id: ele,
  //       name: ele,
  //     }))
  //     this.setState({ states }, () => {
  //       window.$('#city').niceSelect('update')
  //       window.$('.city').on('change', () => {
  //         const data = this.state.data
  //         if (data.city !== window.$('#city').val()) {
  //           data.city = window.$('#city').val()
  //           this.setState({ data })
  //         }
  //       })
  //     })
  //   }
  //   window.$('#state').niceSelect()
  //   window.$('.state').on('change', () => {
  //     const data = this.state.data
  //     if (data.state !== window.$('#state').val()) {
  //       data.state = window.$('#state').val()
  //       this.setState({ data })
  //       this.props.loadCity({ state: data.state })
  //     }
  //   })

  //   window.$('#city').niceSelect()
  //   window.$('.city').on('change', () => {
  //     const data = this.state.data
  //     if (data.city !== window.$('#city').val()) {
  //       data.city = window.$('#city').val()
  //       this.setState({ data })
  //     }
  //   })
  // }

  componentDidUpdate(prevProps) {
    if (
      !this.props.profileLoading &&
      this.props.profileLoading !== prevProps.profileLoading
    ) {
      const clinic1 = this.props.doctorProfile.clinic_details || {};
      const clinic2 = this.props.doctorProfile.clinic_details_2 || {};

      const data = {
        ...this.state.data,

        // Clinic 1
        is_available: clinic1.is_available || false,
        name: clinic1.name || "",
        clinicaddress: clinic1.address || "",
        city: clinic1.cityId || "",
        state: clinic1.state || "",
        zipcode: clinic1.zipcode || "",
        phone: clinic1.is_available ? "" : clinic1.phone || "",
        pics: clinic1.photos ? clinic1.photos.map((e) => e) : [],
        googleProfile: clinic1.googleProfile || "",

        // Clinic 2
        is_available_2: clinic2.is_available || false,
        name_2: clinic2.name || "",
        clinicaddress_2: clinic2.address || "",
        city_2: clinic2.cityId || "",
        state_2: clinic2.state || "",
        zipcode_2: clinic2.zipcode || "",
        phone_2: clinic2.phone || "",
        pics_2: clinic2.photos ? clinic2.photos.map((e) => e) : [],
        googleProfile_2: clinic2.googleProfile || "",
      };

      this.setState({ data });

      this.props.loadState();

      if (data.state) {
        this.props.loadCity({ state: data.state });
      }

      if (data.state_2) {
        this.props.loadCity({ state: data.state_2 });
      }
    }

    if (
      !this.props.getMisc.loadingState &&
      this.props.getMisc.loadingState !== prevProps.getMisc.loadingState
    ) {
      const states = this.props.getMisc.state.map((state) => ({
        value: state,
        label: state,
      }));

      this.setState({ states });
    }

    if (
      !this.props.getMisc.loadingCity &&
      this.props.getMisc.loadingCity !== prevProps.getMisc.loadingCity
    ) {
      const cities = this.props.getMisc.city.map((city) => ({
        value: city._id,
        label: city.city,
      }));

      this.setState({ cities });
    }
  }

  changeBodyClass = () => {
    document.body.classList.add("active");
  };

  handleAvailabilityToggle = (suffix = '') => {

    const data = { ...this.state.data }

    const isAvailableKey = `is_available${suffix}`
    const isAvailable = !data[isAvailableKey]

    data[isAvailableKey] = isAvailable

    const nameKey = `name${suffix}`
    const phoneKey = `phone${suffix}`
    const addressKey = `clinicaddress${suffix}`
    const picsKey = `pics${suffix}`
    const stateKey = `state${suffix}`
    const cityKey = `city${suffix}`
    const zipcodeKey = `zipcode${suffix}`

    data[nameKey] = ''
    data[phoneKey] = ''
    data[addressKey] = ''
    data[picsKey] = []

    if (suffix === '_2') {
      data[stateKey] = ''
      data[cityKey] = ''
      data[zipcodeKey] = ''
    }

    this.setState({ data, errors: {} })

  if (suffix === '_2') {
    this.schema[nameKey] = Joi.string().allow('', null).optional()
    this.schema[phoneKey] = Joi.any().optional()
    this.schema[picsKey] = Joi.array().optional()
    this.schema[addressKey] = Joi.string().allow('', null).optional()
    this.schema[stateKey] = Joi.string().allow('', null).optional()
    this.schema[cityKey] = Joi.string().allow('', null).optional()
    this.schema[zipcodeKey] = Joi.string().allow('', null).optional()

    } else {
      if (isAvailable) {
        this.schema[nameKey] = Joi.any()
        this.schema[phoneKey] = Joi.any()
        this.schema[picsKey] = Joi.any()
        this.schema[addressKey] = Joi.any()
      } else {
        this.schema[phoneKey] = Joi.number()
          .required()
          .min(1000000000)
          .max(999999999999999)
          .error(errors => {
            errors.forEach(err => {
              switch (err.type) {
                case 'any.required':
                  err.message = phoneRequired
                  break
                case 'number.base':
                case 'number.max':
                case 'number.min':
                  err.message = phoneInvalid
                  break
              }
            })
            return errors
          })

        this.schema[nameKey] = Joi.string()
          .required()
          .error(() => ({ message: nameRequired }))

        this.schema[picsKey] = Joi.array()
          .items(Joi.string().required())
          .required()
          .error(() => ({ message: picsRequired }))

        this.schema[addressKey] = Joi.string()
          .required()
          .error(() => ({ message: clinicAddressRequired }))
      }
    }
  }

  renderClinicForm = (suffix = "") => {
    const data = this.state.data;

    return (
      <>
        <div className="row">
          <div className="col-xl-5">
            <div className="form-group">
              <div className="form-check">
                <input
                  className='form-check-input'
                  type='checkbox'
                  id={`is_available${suffix}`}
                  onChange={() => this.handleAvailabilityToggle(suffix)}
                  checked={this.state.data[`is_available${suffix}`]}
                /> 
                <label className='form-check-label' htmlFor={`is_available${suffix}`}>
                  {suffix === '_2'
                    ? "Click here if you don't own or perform consultation in this clinic 2"
                    : "Click here if you don't own or perform consultation in this clinic 1"}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6">
            {this.renderInput(`name${suffix}`, "Name")}
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            {this.renderInput(`phone${suffix}`, "Phone Number", "text")}
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            {this.renderInput(
              `clinicaddress${suffix}`,
              "Clinic Address",
              "text",
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            <Select
              styles={this.customStyles}
              value={this.state.states.find(
                (s) => s.value === this.state.data[`state${suffix}`],
              )}
              options={this.state.states}
              onChange={(selected) => {
                const data = { ...this.state.data };

                data[`state${suffix}`] = selected.value;
                data[`city${suffix}`] = "";

                this.setState({ data });

                this.props.loadCity({ state: selected.value });
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 mt-4">
            <Select
              styles={this.customStyles}
              value={this.state.cities.find(
                (c) => c.value === this.state.data[`city${suffix}`],
              )}
              options={this.state.cities}
              onChange={(selected) => {
                const data = { ...this.state.data };

                data[`city${suffix}`] = selected.value;

                this.setState({ data });
              }}
            />
          </div>
          <div className="col-xl-3 mt-4">
            {this.renderInput(`zipcode${suffix}`, "Zip Code", "text")}
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            <FileInput
              totalUploaded={data[`pics${suffix}`]?.length}
              error={this.state.errors[`pics${suffix}`]}
              label="Upload your clinic logo here if available"
              name={`pics${suffix}`}
              status="Add file"
              onchange={suffix ? this.fileUpload2 : this.fileUpload}
              text={data[`pics${suffix}`]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xl-6">
            <div className="imagePreviewBox">
              {data[`pics${suffix}`]?.map((e) => (
                <div className="imagePreview">
                  <a
                    href="#"
                    onClick={(ele) =>
                      suffix ? this.remoVeImg2(ele, e) : this.remoVeImg(ele, e)
                    }
                    className="imagePreviewClose"
                  >
                    <i className="fas fa-times"></i>
                  </a>

                  <img
                    className="imageClinic"
                    width="180px"
                    src={process.env.REACT_APP_S3URL + e}
                    alt=""
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6">
            {this.renderInput(
              `googleProfile${suffix}`,
              "Google Profile Link",
              "text",
            )}
          </div>
        </div>
      </>
    );
  };
  render() {
    return (
      <React.Fragment>
        <ReactTooltip className="testPurple" />
        <SignUpLeftBar />
        <div className="main-container">
          <div className="main-head">
            <button className="nav-toggler" onClick={this.changeBodyClass}>
              <i className="fas fa-bars"></i>
            </button>
            <a href="#" className="brand-logo">
              <img src="include/images/yes-mindy-logo.svg" alt="" />
            </a>
          </div>
          <HelpText />

          <div className="container ml-0">
            <form onSubmit={this.handleSubmit}>
              <div className="main-heading">
                <h1>Clinic 1 Details</h1>
              </div>
              <div className="main-content">{this.renderClinicForm("")}</div>

              <div className="main-heading">
                <h1>Clinic 2 Details</h1>
              </div>

              <div className="main-content">{this.renderClinicForm("_2")}</div>
              {/* <div className='main-content'>
                <div className='row'>
                  <div className='col-xl-5'>
                    <div className='form-group'>
                      <div className='form-check'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          value=''
                          id='flexCheck1'
                          name='is_available'
                          onChange={() => {
                            const { data } = this.state
                            data.is_available = !data.is_available
                            data.name = ''
                            data.clinicaddress = ''
                            data.pics = []
                            data.phone = ''
                            this.setState({ data, errors: {} })
                            if (data.is_available) {
                              this.schema.phone = Joi.any()
                              this.schema.name = Joi.any()
                              this.schema.pics = Joi.any()
                              this.schema.clinicaddress = Joi.any()
                            } else {
                              this.schema.phone = Joi.number()
                                .required()
                                .min(1000000000)
                                .max(999999999999999)
                                .error(errors => {
                                  errors.forEach(err => {
                                    console.log('errerr', err)
                                    switch (err.type) {
                                      case 'any.required':
                                        err.message = phoneRequired
                                        break
                                      case 'number.base':
                                        err.message = phoneInvalid
                                        break

                                      case 'number.max':
                                        err.message = phoneInvalid
                                        break

                                      case 'number.min':
                                        err.message = phoneInvalid
                                        break
                                    }
                                  })
                                  return errors
                                })
                              this.schema.name = Joi.string()
                                .required()
                                .error(() => {
                                  return { message: nameRequired }
                                })
                              this.schema.pics = Joi.array()
                                .items(Joi.string().required())
                                .required()
                                .error(() => {
                                  return { message: picsRequired }
                                })
                              this.schema.clinicaddress = Joi.string()
                                .required()
                                .error(() => {
                                  return { message: clinicAddressRequired }
                                })
                            }
                          }}
                          checked={this.state.data.is_available}
                        />
                        <label
                          className='form-check-label'
                          htmlFor='flexCheck1'>
                          Click here if you don't own or perform consultation in
                          any clinic
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    {this.renderInput(
                      'name',
                      'Name',
                      'text',
                      this.state.data.is_available
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    {this.renderInput(
                      'phone',
                      'Phone Number',
                      'text',
                      this.state.data.is_available
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    {this.renderInput(
                      'clinicaddress',
                      'Clinic Address',
                      'text',
                      this.state.data.is_available
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    {this.renderSelect('state', 'State', this.state.states)}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-3'>
                    {this.renderSelect(
                      'city',
                      'City',
                      this.props.getMisc.city.map(ele => ({
                        _id: ele._id,
                        name: ele.city,
                      }))
                    )}
                  </div>
                  <div className='col-xl-3'>
                    {this.renderInput('zipcode', 'Zip Code', 'text')}
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    <FileInput
                      totalUploaded={this.state.data.pics.length}
                      error={this.state.errors['pics']}
                      label='Upload your clinic logo here if available'
                      name='pics'
                      status='Add file'
                      onchange={this.fileUpload}
                      text={this.state.data['pics']}
                      disabled={this.state.data.is_available}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    <div className='imagePreviewBox'>
                      {this.state.data.pics.map(e => (
                        <div className='imagePreview'>
                          <a
                            href='#'
                            onClick={ele => this.remoVeImg(ele, e)}
                            className='imagePreviewClose'>
                            <i className='fas fa-times'></i>{' '}
                          </a>
                          <img
                            className='imageClinic'
                            width='180px'
                            src={process.env.REACT_APP_S3URL + e}
                            alt=''
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-xl-6'>
                    {this.renderInput('googleProfile', 'Google Profile Link', 'text')}
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-xl-5">
                  <div className="form-group">
                    <SubmitBtn
                      label="Save & Continue"
                      loading={this.state.loading}
                      btnClass={this.state.btnClass}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  getMisc: getMisc(state),
  profileLoading: getDoctor(state).profileLoading,
  doctorProfile: getDoctor(state).profile,
});

const mapDispatchToProps = (dispatch) => ({
  doctorUpdate: (data, callback) => dispatch(doctorUpdate(data, callback)),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
  loadDoctorProfileForStaff: () => dispatch(loadDoctorProfileForStaff()),
  loadCity: (data) => dispatch(loadCity(data)),
  loadState: () => dispatch(loadState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Clinic);
